import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import SocialChannel from './social-channel/social-channel'

import styles from './social.css'

export default class Social extends PureComponent {
  static propTypes = {
    fluid: PropTypes.bool,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    baseImageUrl: PropTypes.string,
    channels: PropTypes.array.isRequired,
  }

  isFluid = className =>
    this.props.fluid ? styles[`${className}--fluid`] : styles[className]

  render() {
    const { fluid, channels, title, subtitle, baseImageUrl } = this.props
    return (
      <div className={this.isFluid('container')}>
        <div className={this.isFluid('text')}>
          <h3 className={styles['title']}>{title}</h3>
          <p className={styles['description']}>{subtitle}</p>
        </div>
        <ul className={this.isFluid('list')}>
          {channels.map((channel, index) => (
            <SocialChannel
              fluid={fluid}
              key={`${channel.id}-${index}`}
              text={channel.title}
              image={channel.imageUrl}
              link={channel.linkUrl}
              baseImageUrl={baseImageUrl}
            />
          ))}
        </ul>
      </div>
    )
  }
}
